import { render, staticRenderFns } from "./ISAAlertList.vue?vue&type=template&id=1bb3b6d5&scoped=true&"
import script from "./ISAAlertList.vue?vue&type=script&lang=js&"
export * from "./ISAAlertList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb3b6d5",
  null
  
)

export default component.exports